import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { app } from '../app';

app.filter('phoneNumber', phoneNumber);

/** @ngInject */
function phoneNumber() {
    const PNU = PhoneNumberUtil.getInstance();
    return function(input) {
        if (PNU.isPossibleNumberString(input)) {
            const number = PNU.parse(input);
            return PNU.format(number, PhoneNumberFormat.INTERNATIONAL);
        }
    };
}



// WEBPACK FOOTER //
// ./src/portal/filters/phone-number.filter.js